var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "payment-block" },
    [
      _vm._m(0),
      _c("h2", [_vm._v("Pricing Management")]),
      _c("div", { staticClass: "payment-row" }, [
        _c("div", { staticClass: "payment-col" }, [
          _c("div", { staticClass: "payment-text-box" }, [
            _c("h3", { staticClass: "payment-heading" }, [
              _vm._v("Your Subscription Plan"),
            ]),
            _c(
              "div",
              { staticClass: "payment-block-wrap" },
              [
                _c("SubsPlan", {
                  attrs: {
                    company: _vm.company,
                    currentUser: _vm.currentUser,
                    subcription: _vm.currentSubscription,
                  },
                }),
                _c("BillingInfo", {
                  attrs: {
                    company: _vm.company,
                    currentUser: _vm.currentUser,
                    subcription: _vm.currentSubscription,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "payment-col" }, [
          _c(
            "div",
            {
              staticClass: "payment-text-box",
              class: {
                "payment-has-overlay": _vm.isTrialPeriod && _vm.getCancelAt,
              },
            },
            [
              _c("ManagerInfo", {
                attrs: {
                  company: _vm.company,
                  currentUser: _vm.currentUser,
                  subcription: _vm.currentSubscription,
                  totalEnterManagers: _vm.totalEnterManagers,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("h2", [_vm._v("Upgrade your plan today")]),
      _c(
        "div",
        { staticClass: "payment-row", attrs: { id: "subscription" } },
        _vm._l(_vm.plans, function (plan) {
          return _c(
            "div",
            { key: plan.price, staticClass: "payment-col" },
            [
              _c(
                "PaymentPlan",
                _vm._b(
                  {
                    attrs: {
                      id: plan.id,
                      subcription: _vm.currentSubscription,
                      allSubscriptionPlans: _vm.allSubscriptionPlans,
                    },
                    on: { handleUpgrade: _vm.handleConfirmationDialog },
                  },
                  "PaymentPlan",
                  plan,
                  false
                )
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm.isPremimumOrGreaterThen
        ? _c("div", { staticClass: "payment-block-information" }, [
            _c(
              "div",
              { staticClass: "payment-block-information-header" },
              [
                _c("h2", [_vm._v("Invite additional managers")]),
                _c(
                  "UiButton",
                  {
                    staticClass: "button-yellow",
                    attrs: { disabled: _vm.isReachedFiftyLimit },
                    on: {
                      click: function ($event) {
                        _vm.showAddAddtionalManagerDialog = true
                      },
                    },
                  },
                  [_vm._v("Add Additional Managers")]
                ),
              ],
              1
            ),
            _c("p", [
              _vm._v(
                " More than 20 Managers? No problem! Expand your Premium plan with extra managers: add groups of 5 for just $20/month beyond the initial 20 Managers your plan currently allows you to invite to the platform. "
              ),
            ]),
          ])
        : _vm._e(),
      _vm.showConfirmModal
        ? _c("UpgradeSubcription", {
            attrs: {
              company: _vm.company,
              currentUser: _vm.currentUser,
              subcription: _vm.currentSubscription,
              isLoading: _vm.buttonLoading,
              upgradingSubcription: _vm.upgradingSubcription,
              allSubscriptionPlans: _vm.allSubscriptionPlans,
            },
            on: {
              close: _vm.handleClose,
              confirmUpgrade: _vm.handleConfirmUpgrade,
            },
          })
        : _vm._e(),
      _vm.showAddAddtionalManagerDialog
        ? _c("AddAddtionalManager", {
            attrs: {
              company: _vm.company,
              currentUser: _vm.currentUser,
              isLoading: _vm.buttonLoading,
            },
            on: {
              addAdditionalManager: _vm.HandleAddAdditionalManager,
              close: function ($event) {
                _vm.showAddAddtionalManagerDialog = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("ul", { staticClass: "flex-row flex mt-1 pb-10" }, [
        _c("li", { staticClass: "flex items-baseline font-bold" }, [
          _c("span", { staticClass: "flex items-center font-normal" }, [
            _c(
              "p",
              { staticClass: "text-sm text-sub-heading customLineH px-1 mr-2" },
              [_vm._v(" Subscriptions ")]
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }